import { Option } from "rsl-api-106/lib/types";

import { SelectOptionType } from "../types";

export const optionToSelectOption = (options: Option[]): SelectOptionType[] => {
  const opt: SelectOptionType[] = [];
  options.forEach((item) => {
    opt.push({ label: item.label!!, value: item.code!! });
  });
  return opt;
};
